import { useRef } from "react";
import classnames from "classnames";
import PageName from "./components/PageName";

import styles from "./PageHeader.module.scss";

const PageHeader = ({ title, details, className }) => {
  const ref = useRef("");

  function setHeaderHeight() {
    if (typeof window === "object") {
      return document.documentElement.style.setProperty(
        "--label-height",
        `${ref.current?.offsetHeight}px`,
      );
    }
  }

  setHeaderHeight();

  return (
    <div className={classnames(styles.wrapper, className)}>
      <PageName title={title} ref={ref} />
      {details && <div className={styles.details}>Last Update: {details}</div>}
    </div>
  );
};

export default PageHeader;
